// extracted by mini-css-extract-plugin
export default {"containerStyle":"styles_containerStyle__1GrZ5","containerWrapperStyle":"styles_containerWrapperStyle__b1LWN","headerTextStyle":"styles_headerTextStyle__scVPf"};